import { createSelector } from 'reselect'

export const getVideos = state => state.get('videos')

export const getVideosList = createSelector(getVideos, video => video.get('items'))

export const isPendingVideos = createSelector(getVideos, video => video.get('pending'))

export const isLoadedVideos = createSelector(getVideos, video => video.get('loaded'))

export const getVideoIdByThumbnail = createSelector(getVideosList, videoList => thumbnail => {
  const video = videoList.find(el => el.thumbnail.url.indexOf(thumbnail) !== -1)
  return video ? video.hashed_id : null
})

export const getCurrentPage = createSelector(getVideos, video => video.get('currentPage'))
